 <!-- JavaScript for updating quantity in the cart -->
var updateCartButton = document.getElementById("update-cart-btn");
if(updateCartButton != null)
{
updateCartButton.addEventListener("click", function() {
  var elementsLoop = document.querySelectorAll('.cart-item');
  var updates = {};

  elementsLoop.forEach(function(ele, index) {
    console.log(index);
    var variantId = ele.getAttribute('item_variant_id');
    var quantity = document.querySelector('input[data-quantity-variant-id="'+variantId+'"]').value;
    var inputQuantity = Number(quantity);
      
      updates[variantId] = inputQuantity;
  });
    
    var updatesData = {updates};
fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(updatesData)
})
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    console.log(data);
window.location.reload();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });

});
}

 if(window.location.href.includes('collections')){
document.addEventListener("DOMContentLoaded", function() {
 
  var selectElement = document.getElementById("filterSelect");

  // Assuming you want to use the last segment of the URL as the selected value
  const filterUrl = window.location.href.split('/');
  const lastItem = filterUrl[filterUrl.length - 1];
 document.querySelector('#filterSelect option[data-sel="'+lastItem+'"]').setAttribute('selected', 'selected');
});

var selectElement = document.getElementById("filterSelect");

selectElement.addEventListener("change", function() {
  var selectedOption = selectElement.options[selectElement.selectedIndex];

  // Remove "selected" attribute from all options
  for (var i = 0; i < selectElement.options.length; i++) {
    selectElement.options[i].removeAttribute("selected");
  }

  selectedOption.setAttribute("selected", "selected");

  // alert(selectedOption.value);
  window.location.href = selectedOption.value;
});
}




